import { createPatchAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const { usePatch: useReviewerConfigPatch } = createPatchAPI({
  getURL: () => `${BASE_URL}/teacher-classroom-review-config/reviewers/`,
});

export { useReviewerConfigPatch };
